export const pageHelpButtonSx = {
  width: { xs: "100%", md: "auto" },
  minWidth: "86px !important",
  borderColor: "primary.light",
  color: "primary.main",
  fontWeight: "600 !important",
  textTransform: "none !important",
} as const;
